import styled, { css } from 'styled-components'

const Container = styled.div` 
  display: flex;
  flex-direction: row;
  padding: 15px 24px;
  margin-bottom: 25px;
  border-bottom: 1px solid ${props => props.theme.cores.cinza200};
  justify-content: space-between;
  background: ${props => props.theme.cores.branco};

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {        
    background: ${props => props.theme.cores.branco};      
      ${props => ( props.selectedIndex === 0 ) && css`
        background: ${props.theme.cores.cinza100};
      `}

    border-bottom: 2px solid hsla(0,0%,59%,.2); 
    padding: 15px 0px;
    justify-content: ${( { justification } ) => justification || 'center'};
  }
`

const WrapperSteps = styled.div`  
  display: flex;  
`

export { Container, WrapperSteps }
